module.exports = __webpack_public_path__ + "static/media/tiffFileFormatImage.df87217e.tiff";